import { createGlobalState } from 'react-use';

const createModal = createGlobalState(false);
const deleteModal = createGlobalState(false);
const unsavedModal = createGlobalState(false);
const editModal = createGlobalState(false);
const shareModal = createGlobalState(false);
const setDefaultModal = createGlobalState(false);
const unsavedRedirectPath = createGlobalState('');

export enum SavedViewsModals {
  Create = 'create',
  Delete = 'delete',
  Unsaved = 'unsaved',
  Edit = 'edit',
  Share = 'share',
  SetDefault = 'setDefault',
}

/**
 * Controls open + close states for all modals relating to Saved Views
 * These states are accessible from any component
 */
export const useViewsModals = () => {
  const [showCreateModal, setShowCreateModal] = createModal();
  const [showDeleteModal, setShowDeleteModal] = deleteModal();
  const [showUnsavedModal, setShowUnsavedModal] = unsavedModal();
  const [showEditModal, setShowEditModal] = editModal();
  const [showShareModal, setShowShareModal] = shareModal();
  const [showSetDefaultModal, setShowSetDefaultModal] = setDefaultModal();
  // blocked route utilized within the Unsaved Changes modal
  const [redirectPath, setRedirectPath] = unsavedRedirectPath();

  return {
    [SavedViewsModals.Create]: {
      isShown: showCreateModal,
      toggle: (newState?: boolean) => {
        setShowCreateModal(newState ?? !showCreateModal);
      },
    },
    [SavedViewsModals.Delete]: {
      isShown: showDeleteModal,
      toggle: (newState?: boolean) => {
        setShowDeleteModal(newState ?? !showDeleteModal);
      },
    },
    [SavedViewsModals.Unsaved]: {
      isShown: showUnsavedModal,
      redirectPath,
      toggle: (newState?: boolean, path?: string) => {
        setShowUnsavedModal(newState ?? !showUnsavedModal);
        if (path) {
          setRedirectPath(path);
        }
      },
    },
    [SavedViewsModals.Edit]: {
      isShown: showEditModal,
      toggle: (newState?: boolean) => {
        setShowEditModal(newState ?? !showEditModal);
      },
    },
    [SavedViewsModals.Share]: {
      isShown: showShareModal,
      toggle: (newState?: boolean) => {
        setShowShareModal(newState ?? !showShareModal);
      },
    },
    [SavedViewsModals.SetDefault]: {
      isShown: showSetDefaultModal,
      toggle: (newState?: boolean) => {
        setShowSetDefaultModal(newState ?? !showSetDefaultModal);
      },
    },
  };
};
